var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLikedBtn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 19C0 8.50659 8.50659 0 19 0V0C29.4934 0 38 8.50659 38 19V19C38 29.4934 29.4934 38 19 38V38C8.50659 38 0 29.4934 0 19V19Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7012 30.0673C15.988 28.3974 13.4639 26.432 11.1741 24.2065C9.5643 22.6036 8.33876 20.6498 7.59137 18.4943C6.24642 14.3129 7.81741 9.52604 12.2139 8.1094C14.5245 7.36554 17.048 7.79069 18.9951 9.25185C20.9429 7.79248 23.4656 7.36748 25.7764 8.1094C30.1729 9.52604 31.7551 14.3129 30.4101 18.4943C29.6627 20.6498 28.4372 22.6036 26.8274 24.2065C24.5376 26.432 22.0135 28.3974 19.3003 30.0673L19.0064 30.25L18.7012 30.0673Z",
    fill: "#FF0000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6741 12.8163C25.0058 13.2416 25.9519 14.4371 26.0701 15.8437",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikedBtn);
export default __webpack_public_path__ + "static/media/liked-btn.b0d746064069b3ae651a0454a7196c5e.svg";
export { ForwardRef as ReactComponent };